import React from 'react';
import { MessageSquare, ArrowRight } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';
import { useNavigate } from 'react-router-dom';

const CartSidebar = () => {
  const { isCartOpen, setIsCartOpen } = useCart();
  const navigate = useNavigate();

  return (
    <Sheet open={isCartOpen} onOpenChange={setIsCartOpen}>
      <SheetContent className="w-full sm:max-w-lg">
        <SheetHeader>
          <SheetTitle className="text-2xl font-display">Get in Touch</SheetTitle>
        </SheetHeader>

        <div className="flex flex-col h-full">
          <div className="flex-1 flex flex-col items-center justify-center text-center py-12">
            <MessageSquare className="h-16 w-16 text-[#D4AF37] mb-4" />
            <p className="text-lg font-medium text-gray-900 mb-2">Interested in our products?</p>
            <p className="text-gray-500 mb-6 max-w-sm">
              We offer customized pricing for every client. Reach out to us for a personalized quote tailored to your needs.
            </p>
            <div className="space-y-3 w-full max-w-xs">
              <Button
                data-testid="sidebar-quote-btn"
                onClick={() => {
                  setIsCartOpen(false);
                  navigate('/contact');
                }}
                className="w-full bg-[#D4AF37] hover:bg-[#C5A028] text-[#0a1128] font-semibold h-12"
              >
                Request a Quote
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button
                data-testid="sidebar-catering-btn"
                onClick={() => {
                  setIsCartOpen(false);
                  navigate('/event-catering');
                }}
                variant="outline"
                className="w-full border-[#0a1128] text-[#0a1128] hover:bg-[#0a1128] hover:text-white h-12"
              >
                Event Catering
              </Button>
              <Button
                data-testid="sidebar-close-btn"
                onClick={() => setIsCartOpen(false)}
                variant="ghost"
                className="w-full text-gray-500"
              >
                Continue Browsing
              </Button>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default CartSidebar;
